// src/components/ProductoAtributosEditor/index.js
import ProductoAtributosEditor from './ProductoAtributosEditor'

export { ProductoAtributosEditor }
export default ProductoAtributosEditor